import React from 'react';
import './Navbar.css';

const Navbar = () => {

    return (
        <>
            <nav className="dnw-nav">
                <div className="dnw-nav-l">
                    <div className="dnw-nav-r">
                        <div className="nav-menu ddsmoothmenu">
                            <div className="dropdown nav-item">
                                <button className="dropbtn">Minh Ngọc ™
                                </button>
                                <div className="dropdown-content">
                                    <li><a href="/"><span>Đại Lý Vé Số</span></a>
                                    </li>
                                    <li>
                                        <a href="/"><span>Giới Thiệu Hệ Thống</span></a>
                                    </li>
                                    <li><a href="/"><span>Liên Hệ Góp Ý</span></a></li>
                                </div>
                            </div>
                            <div className="dropdown nav-item">
                                <button className="dropbtn">Trực Tiếp
                                </button>
                                <div className="dropdown-content">
                                    <li><a href="/"><span>Trực Tiếp Xổ Số Miền Nam</span></a>
                                    </li>
                                    <li><a href="/"><span>Trực Tiếp Xổ Số Miền Bắc</span></a>
                                    </li>
                                    <li><a href="/"><span>Trực Tiếp Xổ Số Miền Trung</span></a>
                                    </li>
                                    <li><a href="/"><span>Trực Tiếp Kết Quả Bóng Đá</span></a>
                                    </li>
                                    <li><a href="/"><span>Lịch Quay Số Mở Thưởng</span></a>
                                    </li>
                                </div>
                            </div>
                            <div className="dropdown nav-item">
                                <button className="dropbtn">Sổ Kết Quả
                                </button>
                                <div className="dropdown-content">
                                    <li><a href="/"><span>KQXS Miền Nam</span></a></li>
                                    <li><a href="/"><span>KQXS Miền Bắc</span></a></li>
                                    <li><a href="/"><span>KQXS Miền Trung</span></a></li>
                                    <li><a href="/"><span>KQXS Điện Toán</span></a></li>
                                </div>
                            </div>
                            <div className="dropdown nav-item">
                                <button className="dropbtn">Sớ Đầu Đuôi
                                </button>
                                <div className="dropdown-content">
                                    <li><a href="/"><span>Sớ Miền Nam</span></a></li>
                                    <li><a href="/"><span>Sớ Miền Bắc</span></a></li>
                                    <li><a href="/"><span>Sớ Miền Trung</span></a></li>
                                </div>
                            </div>
                            <div className="dropdown nav-item">
                                <button className="dropbtn">Thống Kê
                                </button>
                                <div className="dropdown-content">
                                    <li><a href="/"><span>Thống Kê Theo Tỉnh</span></a></li>
                                    <li><a href="/"><span>Thống Kê Lô</span></a></li>
                                    <li><a href="/"><span>Kiểm Tra Gan Cực Đại</span></a></li>
                                    <li><a href="/"><span>Thống Kê Tần Suất</span></a></li>
                                    <li><a href="/"><span>Thống Kê Tần Suất Chi Tiết</span></a></li>
                                    <li><a href="/"><span>Thống Kê Theo Miền</span></a></li>
                                    <li><a href="/"><span>Thống Kê Lô</span></a></li>
                                    <li><a href="/"><span>Kiểm Tra Gan Cực Đại</span></a></li>
                                    <li><a href="/"><span>Thống Kê Tần Suất</span></a></li>
                                    <li><a href="/"><span>Thống Kê Tần Suất Chi Tiết</span></a></li>
                                </div>
                            </div>
                            <div className="dropdown nav-item">
                                <a href="/"><span>Vé Số</span></a>
                            </div>
                            <div className="dropdown nav-item">
                                <a href="/"><span>In Vé Dò</span></a>
                            </div>
                            <div className="dropdown nav-item">
                                <a href="/"><span>Thông Tin</span></a>
                            </div>
                            <div className="dropdown nav-item">
                                <a href="/">ĐỔI SỐ TRÚNG</a>
                            </div>
                            <div className="dropdown nav-item">
                                <button className="dropbtn">Help ?
                                </button>
                                <div className="dropdown-content">
                                    <li><a href="/">IN VÉ DÒ TRÊN CHROME</a></li>
                                    <li><a href="/">THIẾT LẬP KHỔ GIẤY A4</a></li>
                                    <li><a href="/">IN VÉ DÒ TRÊN FIREFOX</a></li>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );

};

export default Navbar;
